import { Typography } from "@codat/orchard-ui";
import * as React from "react";
import Moment from "react-moment";

import styles from "../../CompaniesTable/CompaniesTable.module.css";

interface CompanyNameModel {
  key: "company";
  value: {
    lastSeen: Date;
  };
}

const LastSeenCell: React.FC<Pick<CompanyNameModel, "value">> = ({ value }) => {
  return (
    <Typography
      className={styles.lastSeen}
      data-testid="last-seen-time"
      as="p"
      variant="body_sm"
    >
      <Moment format="YYYY-MM-DD, HH:mm">{value.lastSeen}</Moment>
    </Typography>
  );
};

export default LastSeenCell;
